var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Icons_FlipCalendar_M",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 15C68 14.4477 67.5523 14 67 14 66.4477 14 66 14.4477 66 15L66 20 30 20 30 15C30 14.4477 29.5523 14 29 14 28.4477 14 28 14.4477 28 15L28 20 14 20 14 82 82 82 82 20 68 20ZM80 80 16 80 16 37 80 37ZM80 22 80 35 16 35 16 22 28 22 28 26C28 26.5523 28.4477 27 29 27 29.5523 27 30 26.5523 30 26L30 22 66 22 66 26C66 26.5523 66.4477 27 67 27 67.5523 27 68 26.5523 68 26L68 22Z",
    fill: "#86BC25"
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.6667px",
      lineHeight: 1.25,
      fontFamily: "'Segoe UI'",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none"
    },
    x: 46.988907,
    y: 53.873917,
    id: "date"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "date",
    x: 46.988907,
    y: 53.873917,
    style: {
      textAlign: "center",
      textAnchor: "middle"
    }
  }, "1er Juillet"), /*#__PURE__*/React.createElement("tspan", {
    id: "year",
    x: 46.988907,
    y: 67.207298,
    style: {
      textAlign: "center",
      textAnchor: "middle"
    }
  }, "2024"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.96b8547f7ec1ef919cad3681fd0bb814.svg";
export { ForwardRef as ReactComponent };